module.exports = __webpack_public_path__ + "static/media/wUSDC.72fef48f.png";